// src/services/recordbookService.ts
import api from '../utils/api';
import localStorageService from "./localStorageService";

import { RECORD_NOTICE, RECORD_NOTICE_PLAYERS, RECORD_CATEGORIES } from "../constants/routes";
class RecordBookService {
  public getRecordStats = async (payload: { SportCode: string; Category: string }) => {
    // Get auth token from local storage
    const userInfo = localStorageService.getUserInfo();
    const token = userInfo?.access_token || "";

    try {
      const response = await api.post(RECORD_NOTICE, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response from backend", response);
      return response.data; // return only data
    } catch (error: any) {
      console.error("Error fetching record stats", error);
      throw error;
    }
  };



   public getRecordPlayers = async (payload: { 
        SportCode: string; 
        Category: string;
        TeamCode: string;
        Entity: string;
        Period: string;
    }) => {
        const userInfo = localStorageService.getUserInfo();
        const token = userInfo?.access_token || "";

        try {
            const response = await api.post(RECORD_NOTICE_PLAYERS, {
                ...payload,
                action: "getPlayers" // still send action if backend expects it
            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            // backend already returns { total_count, players }
            return response.data;
        } catch (error: any) {
            console.error("Error fetching record players:", error);
            throw error;
        }
    };

    public getRecordCategories = async (sportCode: string, entity: string) => {
    const userInfo = localStorageService.getUserInfo();
    const token = userInfo?.access_token || "";

    try {
        const response = await api.get(
            `${RECORD_CATEGORIES}?sport_code=${sportCode}&entity=${entity}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Error fetching categories:", error);
        throw error;
    }
};
}

export default new RecordBookService();
